__turbopack_context__.v({
  "changeNegative": "TopBarStats-module__-H9ODa__changeNegative",
  "changePositive": "TopBarStats-module__-H9ODa__changePositive",
  "container": "TopBarStats-module__-H9ODa__container",
  "gasGroup": "TopBarStats-module__-H9ODa__gasGroup",
  "label": "TopBarStats-module__-H9ODa__label",
  "priceGroup": "TopBarStats-module__-H9ODa__priceGroup",
  "priceText": "TopBarStats-module__-H9ODa__priceText",
  "separator": "TopBarStats-module__-H9ODa__separator",
  "shimmer": "TopBarStats-module__-H9ODa__shimmer",
  "skeleton": "TopBarStats-module__-H9ODa__skeleton",
});
